import LangRedirection from "./LangRedirection";

export default LangRedirection;
